import React from "react";
import styled from "styled-components";
import { Button } from "reactstrap";
import { FiEdit } from "react-icons/fi";

const WhiteBoardButton = ({
  className,
  openWhiteboard,
  buyplanItem
}) => {
  var size = buyplanItem.get("items") ? buyplanItem.get("items").size : 0;
  if (!size) className += ' disabledButton';
  return (
    <Button
      className={`${className}`}
      onClick={() => openWhiteboard(buyplanItem)}
    >
      <FiEdit className={`editDnd`} /> Whiteboard
    </Button>
  );
};

const StyledWhiteBoardButton = styled(WhiteBoardButton)`
  color: var(--brandscope-blue) !important;
  background-color: #ffffff;
  border-color: var(--brandscope-blue) !important;
  font-size: 14px;
  text-align: center;
  padding: 3px 6px 3px 1px;
  margin-left: 20px;

  &:hover {
    border-bottom-color: var(--badge-secondary-bg-color) !important;
    color: #ffffff !important;
  }
`;

export default React.memo(StyledWhiteBoardButton);
